import { Component, OnInit, Input, EventEmitter, Output } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "app-input-select",
  templateUrl: "./input-select.component.html",
  styleUrls: ["./input-select.component.css"]
})
export class InputSelectComponent implements OnInit {
  @Input() dataList: any[];
  @Input() isDataObject: boolean = true;
  @Input() title: string;
  @Input() displayFields: string[]; // Alan adları için dizi
  @Input() initialItem: any;
  @Input() translateKey: string; // Çeviri anahtarı için
  @Output() passEntry: EventEmitter<any> = new EventEmitter();

  constructor(
    private translate: TranslateService
  ) {
  }

  ngOnInit() { }

  getDisplayText(item: any): string {
    if (!this.isDataObject) {
      // Eğer translateKey varsa çeviri yap
      if (this.translateKey) {
        return this.translate.instant(this.translateKey + '.' + item);
      }
      return item;
    }

    return this.displayFields.map(field => item[field]).join(' ');
  }

  selectItem(item) {
    this.passEntry.emit(item);
  }

  close() {
    this.passEntry.emit();
  }
}
